<template>
  <v-container class="page">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-card
      width="100%"
      style="border-radius:10px;"
      class="pa-3"
      v-show="!overlay"
    >
      <v-card-title class="title font-weight-light">
        User Approval
        <v-spacer />
        <v-text-field
          v-model="searchData"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        />
      </v-card-title>
      <v-card-text>
        <div class="d-flex">
          <v-checkbox
            v-model="showRejectUser"
            :label="`Show rejected users`"
            class="mt-5 ml-auto"
          />
        </div>
        <v-data-table
          :headers="headers"
          :items="userApproval"
          sort-by="index"
          class="font-weight-light"
          :loading="loadingUser"
          :footer-props="footerProps"
          @update:options="updatePaging"
          :server-items-length="userTotal"
          :options.sync="paginationOptions"
        >
          <template #body="{ items }">
            <tbody>
              <tr
                v-if="!items.length"
                class="v-data-table__empty-wrapper"
              >
                <td colspan="9">
                  No data available
                </td>
              </tr>
              <tr
                v-else
                :class="item.status == 0 ? '' : 'custom-highlight-row'"
                v-for="item in items"
                :key="getKey(item.username)"
              >
                <td>{{ (paginationOptions.page - 1) * paginationOptions.itemsPerPage + (items.indexOf(item) + 1) }}</td>
                <td>{{ item.username }}</td>
                <td>{{ setFullname(item) }}</td>
                <td>{{ setMetadata(item, 0) }}</td>
                <td>{{ setMetadata(item, 1) }}</td>
                <td>{{ setMetadata(item, 2) }}</td>
                <td>{{ setMetadata(item, 3) }}</td>
                <td>{{ dateOnlyFormat(item.metadata) }}</td>

                <td>
                  <!-- <a @click="showPhoto(item)">Show</a> -->
                  <v-icon
                    small
                    color="blue"
                    v-if="item.metadata.photo"
                    @click="showPhoto(item)"
                  >
                    mdi-eye
                  </v-icon>
                  <v-dialog
                    v-model="showPhotoDialog"
                    max-width="500"
                    class="mx-auto"
                  >
                    <v-card v-if="!dontHavePhoto">
                      <v-img
                        :src="photoUrl"
                      />
                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="error"
                          text
                          @click="handleClosePhoto"
                        >
                          Close
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                    <v-card v-else>
                      <v-card-title class="justify-center pa-10">
                        <v-icon size="90">
                          mdi-close-octagon
                        </v-icon>
                      </v-card-title>
                      <v-card-title class="justify-center">
                        No photo available
                      </v-card-title>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="error"
                          text
                          @click="handleClosePhoto"
                        >
                          Close
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </td>
                <td>{{ setStatus(item) }}</td>
                <td>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      v-if="item.status == 0 || item.status == 3"
                    >
                      <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                          <v-btn
                            icon
                            small
                            color="green"
                            @click="nextDialog(item)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon small>
                              mdi-check-bold
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Approve</span>
                      </v-tooltip>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      v-if="item.status == 0"
                    >
                      <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                          <v-btn
                            icon
                            small
                            color="red"
                            @click="dialog3 = true; userToReject = item;"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon small>
                              mdi-close
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Reject</span>
                      </v-tooltip>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      v-if="item.status == 3"
                    >
                      <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                          <v-btn
                            icon
                            small
                            color="red"
                            @click="dialog4 = true; userToDelete = item"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon small>
                              mdi-delete
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Delete</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </td>
              </tr>
            </tbody>
            <v-dialog
              v-model="dialog"
              persistent
              max-width="500"
            >
              <v-card
                dark
                color="green"
              >
                <v-card-title>
                  <span>
                    <v-icon>mdi-alert-circle</v-icon> Are you sure want to
                    approve this user?
                  </span>
                </v-card-title>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    text
                    @click="closeModal()"
                  >
                    No
                  </v-btn>
                  <v-btn
                    text
                    @click="approveUser()"
                    :loading="loadingUpdate"
                    :disabled="loadingUpdate"
                  >
                    Yes
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialog2"
              max-width="900px"
              persistent
            >
              <v-card>
                <v-card-title />
                <v-card-text>
                  <v-form
                    ref="approvalForm"
                    v-model="valid"
                    lazy-validation
                  >
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        class="my-0"
                      >
                        <v-combobox
                          v-model="assetGroup"
                          :items="assetGroups"
                          item-text="name"
                          item-value="id"
                          label="Asset Group"
                          multiple
                          outlined
                          required
                          hide-details
                          :rules="[(v) => v.length ? null : 'Please select at least one group!']"
                        >
                          <template #selection="{ item, index }">
                            <v-chip v-if="index === 0">
                              <span>{{ item.name }}</span>
                            </v-chip>
                            <span
                              v-if="index === 1"
                              class="grey--text caption"
                            >
                              (+{{ assetGroup.length - 1 }} others)
                            </span>
                          </template>
                        </v-combobox>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        v-if="userItem.metadata"
                      >
                        <v-select
                          hide-details
                          :items="rfid_types"
                          :item-text="(rfid_type) => `${rfid_type.name}`"
                          :item-value="(rfid_type) => `${rfid_type.name}`"
                          label="RFID Type"
                          outlined
                          v-model="userItem.metadata.rfid_type"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        v-if="userItem.metadata && userItem.metadata.rfid_type"
                      >
                        <v-text-field
                          outlined
                          hide-details
                          color="success"
                          label="Key Cabinet RFID"
                          v-model="userItem.metadata.key_cabinet_rfid"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                      >
                        <v-checkbox
                          class="my-0"
                          dense
                          hide-details
                          v-model="checkbox"
                          label="Allowing this user to book for others"
                          color="info"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        v-show="false"
                      >
                        <v-divider />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        v-show="false"
                      >
                        <v-autocomplete
                          v-model="userManage"
                          :items="userDatas"
                          :item-text="(item) => `${item.first_name} ${item.last_name ? item.last_name : ''}`"
                          :item-value="(item) => `${item.id}`"
                          multiple
                          clearable
                          auto-select-first
                          label="Select user wants to manage"
                          outlined
                          required
                          hide-details
                        >
                          <template #selection="{ item, index }">
                            <v-chip v-if="index === 0">
                              <span>{{ item.first_name }} {{ item.last_name }}</span>
                            </v-chip>
                            <span
                              v-if="index === 1"
                              class="grey--text caption"
                            >
                              (+{{ userManage.length - 1 }} others)
                            </span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    text
                    @click="closeModal2()"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    @click="closeAndShow()"
                  >
                    Next
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialog3"
              persistent
              max-width="500"
            >
              <v-card
                dark
                color="red"
              >
                <v-card-title>
                  <span>
                    <v-icon>mdi-alert-circle</v-icon> Are you sure want to
                    reject this user?
                  </span>
                </v-card-title>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    text
                    @click="dialog3 = false"
                  >
                    No
                  </v-btn>
                  <v-btn
                    text
                    @click="rejectUser()"
                    :loading="loadingUpdate"
                    :disabled="loadingUpdate"
                  >
                    Yes
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialog4"
              persistent
              max-width="500"
            >
              <v-card
                dark
                color="red"
              >
                <v-card-title>
                  <span>
                    <v-icon>mdi-alert-circle</v-icon> Are you sure want to
                    delete this user?
                  </span>
                </v-card-title>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    text
                    @click="dialog4 = false"
                  >
                    No
                  </v-btn>
                  <v-btn
                    text
                    @click="deleteUser()"
                    :loading="loadingUpdate"
                    :disabled="loadingUpdate"
                  >
                    Yes
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <template #no-data>
            <v-skeleton-loader
              class="mx-auto"
              type="table-tbody"
            />
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
/* eslint-disable */
const qs = require("qs");
const uniqueId = require("lodash/uniqueId");
const get = require("lodash/get");
import isNull from 'lodash/isNull';
import isEmpty from 'lodash/isEmpty';
import BigNumber from "bignumber.js";
import moment from "moment";


export default {
  data: () => ({
    token: "",
    clientid: "",
    headers: [
      { text: "No ", value: "index", sortable: false },
      { text: "Username", value: "username" },
      { text: "Fullname ", value: "fullname", sortable: false },
      { text: "Issuing State", value: "metadata.driver_license.issuing_state", sortable: false },
      { text: "Licence Type", value: "metadata.driver_license.license_type", sortable: false },
      { text: "Conditions", value: "metadata.driver_license.conditions", sortable: false },
      { text: "Licence No", value: "metadata.driver_license.license_no", sortable: false },
      { text: "Expiry Date", value: "metadata.driver_license.expiry_date", sortable: false },
      { text: "Photo of Licence", value: "metadata.photo", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Actions", value: "action", sortable: false },
    ],
    rfid_types: [
      {
        name: 'RFID Card'
      },
      {
        name: 'RFID Key Ring'
      },
      {
        name: 'RFID Sticker'
      }
    ],
    rfidTypeRules: [(v) => !!v || "RFID Type is required"],
    keyCabinetRFIDRules: [(v) => !!v || "Key Cabinet RFID is required"],
    dialog: false,
    dialog2: false,
    dialog3: false,
    dialog4: false,
    showRejectUser: false,
    showPhotoDialog: false,
    photoUrl: "",
    vhcTypes: [],
    vhcTypeId: [],
    vehicle_type: [],
    userItem: {},
    checkbox: false,
    userManage: [],
    userDatas: [],
    vhcTypeData: [],
    assetGroups: [],
    assetGroup: [],
    groupParam: [],
    valid: false,
    loadingUpdate: false,
    loader: null,
    searchData: "",
    overlay: false,
    dontHavePhoto: false,
    loadingUser: false,
    searchTimeout: null,
    toggleTimeout: null,
    footerProps: {
      itemsPerPageOptions: [2, 3, 5, 10, 20, 50, 100, 200, 500]
    },
    paginationOptions: {
      sortBy: [],
      sortDesc: [],
      page: 1,
      itemsPerPage: 10
    },
    userToReject: {},
    userToDelete: {}
  }),
  created() {
    this.token = this.$store.state.token;
    this.clientid = this.$store.state.clientid;
    this.$store.commit('CLEAR_USER_APPROVAL');
    this.$store.commit('CLEAR_USER_APPROVAL_TOTAL');
    this.$store.dispatch("LOAD_USER_APPROVAL_TOTAL", { query: this.searchData, status: [0] });
    this.$store.dispatch("LOAD_USER_APPROVAL", { offset: 0, limit: 10, sort_by: 'id', sort_dir: 'desc', query: this.searchData, status: [0] });
    this.getVhcTypes();
    this.getAssetGroups();
    this.overlay = true;
  },
  computed: {
    userApproval() {
      const userApproval = this.$store.getters.getUserApprovalData;
      const userApprovals = userApproval.map((items, index) => ({
        ...items,
        index: (index + 1).toString()
      }))
      return userApprovals;
    },
    userTotal() {
      const total = this.$store.getters['getUserApprovalTotal']
      return parseInt(total)
    }
  },
  mounted() {
    this.getVhcTypes()
  },
  watch: {
    vhcTypeId(value) {
      this.vehicle_type = [];
      if(value.length) {
        value.forEach((v) => {
          this.vehicle_type.push({id: v, approve: 1});
        });
      }
    },
    assetGroup(val) {
      if (isNull(val)) return;
      this.groupParam = val.map((v) => v.id);
    },
    loader() {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    },
    overlay(val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 2e3)
    },
    showRejectUser() {
      clearTimeout(this.toggleTimeout)
      this.toggleTimeout = setTimeout(() => {
        this.paginationOptions.page     = 1;
        this.paginationOptions.sortBy   = [];
        this.paginationOptions.sortDesc = [];
        this.updatePaging(this.paginationOptions)
      }, 1e3)
    },
    searchData(value) {
      this.doSearch();
    },
  },
  methods: {
    dateOnlyFormat (item) {
      let get_date = get(item.driver_license, "expiry_date", null);
      if (get_date == null) return;
      get_date = moment(get_date).format('D MMM YYYY')
      // let date = null;
      // if(item.hasOwnProperty("created_at")){
      //   date =  moment(item.created_at).format('D MMM YYYY hh:mm A')
      // }
      return get_date;
    },
    handleClosePhoto() {
      this.showPhotoDialog = false;
      this.dontHavePhoto = false;
    },
    deleteUser() {
      const item = this.userToDelete
      this.loadingUpdate = true;
      this.loader = this.loadingUpdate;
      this.$store.dispatch('API_CALL', {
          $method: 'delete_user',
          $postData: {
            clientid: this.clientid,
            id: item.id,
          },
        })
        .then((response) => {
          if(response.data.code == 200) {
            this.dialog4 = false;
            this.loadingUpdate = false;
            this.loader = this.loadingUpdate;

            this.$swal({
              icon: "success",
              title: response.data.data.message,
            }).then((res) => {
              if (res.isConfirmed) {
                this.$store.commit('CLEAR_USER_APPROVAL');
                this.$store.commit('CLEAR_USER_APPROVAL_TOTAL');
                this.$store.dispatch("LOAD_USER_APPROVAL_TOTAL", { query: this.searchData, status: [0] });
                this.$store.dispatch("LOAD_USER_APPROVAL", { offset: 0, limit: 10, sort_by: 'id', sort_dir: 'desc', query: this.searchData, status: [0] });
                // location.reload();
                this.showRejectUser = false
                Promise.all([
                  this.$store.dispatch("LOAD_USER_APPROVAL_TOTAL", { query: this.searchData, status: [0] }),
                  this.$store.dispatch("LOAD_USER_APPROVAL", { offset: 0, limit: 10, sort_by: 'id', sort_dir: 'desc', query: this.searchData, status: [0] }),
                ]).then(() => {
                  // Total data ada, tapi di page ini kosong
                  if (this.userTotal > 0 && this.userApproval.length === 0) {
                    // reset page ke page 1
                    this.paginationOptions.page = 1
                    this.$store.dispatch("LOAD_USER_APPROVAL_TOTAL", { query: this.searchData, status: [0] });
                    this.$store.dispatch("LOAD_USER_APPROVAL", { offset: 0, limit: 10, sort_by: 'id', sort_dir: 'desc', query: this.searchData, status: [0] });
                  }
                })
              }
            });
          }
        })
    },
    closeAndShow() {
      if (this.$refs.approvalForm.validate()) {
        this.dialog2 = false;
        this.dialog = true;
      }
    },
    setMetadata(item, type) {
      if (item.metadata !== null) {
        if (typeof item.metadata === "string") {
          const user = JSON.parse(item.metadata);
          switch (type) {
            case 0:
              return user.driver_license.issuing_state;
              break;
            case 1:
              return user.driver_license.license_type;
              break;
            case 2:
              return user.driver_license.conditions;
              break;
            case 3:
              return user.driver_license.license_no;
              break;
            case 4:
              return user.driver_license.expiry_date;
              break;
            default:
              break;
          }
        } else if (typeof item.metadata === "object") {
          switch (type) {
            case 0:
              return item.metadata.driver_license
                ? item.metadata.driver_license.issuing_state
                : undefined;
              break;
            case 1:
              return item.metadata.driver_license
                ? item.metadata.driver_license.license_type
                : undefined;
              break;
            case 2:
              return item.metadata.driver_license
                ? item.metadata.driver_license.conditions
                : undefined;
              break;
            case 3:
              return item.metadata.driver_license
                ? item.metadata.driver_license.license_no
                : undefined;
              break;
            case 4:
              return item.metadata.driver_license
                ? item.metadata.driver_license.expiry_date
                : undefined;
              break;
            default:
              break;
          }
        }
      }
    },
    setFullname(item) {
      let fullName = item.first_name
      if (item.last_name) fullName += item.last_name;
      return fullName;
    },
    setStatus(item) {
      let status = null;
      if (item.status == 0) {
        status = "Registered";
      } else if (item.status == 1) {
        status = "Approved";
      } else if (item.status == 2) {
        status = "Disabled";
      } else if (item.status == 3) {
        status = "Rejected";
      }
      return status;
    },
    nextDialog(item) {
      this.userItem = item;
      this.dialog2 = true;
      let assetGroup = get(item, 'metadata.asset_group', '');
      assetGroup = assetGroup ? assetGroup.split(',') : [];
      assetGroup = assetGroup.filter((v) => this.assetGroups.find((a) => parseInt(a.id) === parseInt(v)));
      this.assetGroup = assetGroup.map((v) => this.assetGroups.find((a) => parseInt(a.id) === parseInt(v)));
    },
    approveUser() {
      this.apiUpdateUser(this.userItem, 1);
    },
    rejectUser() {
      this.apiUpdateUser(this.userToReject, 3);
    },
    apiUpdateUser(item, status) {
      this.clientid = this.$store.state.clientid;
      this.token = this.$store.state.token;
      let sendEmail = null;
      if (status == 1) {
        sendEmail = 1;
      } else if (status == 3) {
        sendEmail = 0;
      }
      var datas = {
        metadata: {
          driver_license: {
            issuing_state: this.setMetadata(item, 0),
            license_type: this.setMetadata(item, 1),
            conditions: this.setMetadata(item, 2),
            license_no: this.setMetadata(item, 3),
            expiry_date: this.setMetadata(item, 4),
          },
          photo: item.metadata.photo,
          rfid_type: item.metadata.rfid_type,
          key_cabinet_rfid: item.metadata.key_cabinet_rfid,
          key_cabinet_rfid_bin: this.getBinaryRFID(),
          vehicle_type: JSON.stringify(this.vehicle_type),
          user_manage: this.userManage,
          as_manager: this.checkbox,
        },
        clientid: this.clientid,
        status: status,
        send_email: sendEmail,
        manager_id: item.id,
      };

      const userIds = this.userDatas.reduce((arr, value) => {
        arr.push(value.id);
        return arr;
      }, [])
      if (datas.metadata.as_manager == true || datas.metadata.as_manager == 'true') {
        datas.metadata.user_manage = userIds;
      }
      this.loadingUpdate = true;
      this.loader = this.loadingUpdate;
      // let paramGroup = this.groupParam;
      this.$store.dispatch('API_CALL', {
          $method: 'update_user',
          $postData: {
            id: item.id,
            data: datas,
          },
        })
        .then(() => {
          this.$store.dispatch('API_CALL', {
              $method: 'update_asset_group_user',
              $postData: {
                user_id: item.id,
                group_id: this.groupParam.join(),
              },
            })
            .then((response) => {
              if (!response.data.data.error) {
                if (status === 1) {
                  this.dialog = false;
                } else {
                  this.dialog3 = false;
                }
                this.loadingUpdate = false;
                this.loader = this.loadingUpdate;

                let title = status === 1 ? "Success approve user." : "Success reject user.";
                this.$swal({
                  icon: "success",
                  title: title,
                }).then((res) => {
                  if (res.isConfirmed) {
                    location.reload();
                  }
                });
              }
            });
        });
    },
    getKey(username) {
      return `${username}_${uniqueId()}`;
    },
    showPhoto(item) {
      let getPhoto = get(item.metadata, "photo", "");
      this.showPhotoDialog = true;
      if(isEmpty(getPhoto)) {
        this.dontHavePhoto = true;
      } else {
        this.photoUrl = `${process.env.VUE_APP_API_URL}/${item.metadata.photo}`;
      }
    },

    closeModal() {
      this.dialog = false;
      // this.clean();
    },
    closeModal2() {
      this.dialog2 = false;
      // this.clean();
    },
    clean() {
      // this.vhcTypeId = null;
      this.vehicle_type = [];
      this.checkbox = false;
      this.userManage = [];
      // this.assetGroup = [];
    },
    getVhcTypes() {
      return this.$store.dispatch('API_CALL', {
          $method: 'get_vehicle_types',
          $postData: {
            clientid: this.clientid,
          },
        })
        .then((response) => {
          this.vhcTypeData = response.data.data
        });
    },
    getAssetGroups() {
      this.token = this.$store.state.token;
      this.$store.dispatch('API_CALL', {
          $method: 'get_asset_groups',
          $postData: {
            clientid: this.$store.state.user.user.clientid,
          },
        })
        .then((response) => {
          this.assetGroups = response.data.data;
        });
    },
    hex2bin(hex){
      if (typeof hex != 'String') {
        try {
          hex = hex.toString();
        } catch(e) {
          hex = "";
        }
      }
      hex = hex.replace("0x", "").toLowerCase();
      var out = "";
      for (let c of hex) {
        switch(c) {
          case '0': out += "0000"; break;
          case '1': out += "0001"; break;
          case '2': out += "0010"; break;
          case '3': out += "0011"; break;
          case '4': out += "0100"; break;
          case '5': out += "0101"; break;
          case '6': out += "0110"; break;
          case '7': out += "0111"; break;
          case '8': out += "1000"; break;
          case '9': out += "1001"; break;
          case 'a': out += "1010"; break;
          case 'b': out += "1011"; break;
          case 'c': out += "1100"; break;
          case 'd': out += "1101"; break;
          case 'e': out += "1110"; break;
          case 'f': out += "1111"; break;
          default: return "";
        }
      }
      return out;
    },
    getBinaryRFID() {
      const key_cabinet_rfid = get(this.editedItem, 'metadata.key_cabinet_rfid', '');
      const rfid_type        = get(this.editedItem, 'metadata.rfid_type', '');

      if (key_cabinet_rfid == "") return null;

      let bin = null;

      switch (rfid_type) {
        case 'RFID Card':
          const rfid_card = key_cabinet_rfid.substr(-6);
          bin = `1${this.hex2bin(rfid_card)}0`;
          break;
        case 'RFID Key Ring':
          const rfid_key_ring = key_cabinet_rfid.substr(-6);
          bin = `0${this.hex2bin(rfid_key_ring)}0`;
          break;
        case 'RFID Sticker':
          let rfid_sticker = key_cabinet_rfid.substr(-6);
          rfid_sticker = new BigNumber(rfid_sticker, 16).minus(1).toString(16);
          bin = `0${this.hex2bin(rfid_sticker)}0`;
          break;
        default:
          break;
      }

      return bin;
    },
    updatePaging(options) {
      this.loadingUser = true;
      const status = [0]
      if (this.showRejectUser) status.push(3)
      this.$store.commit('CLEAR_USER_APPROVAL_TOTAL');
      this.$store.dispatch("LOAD_USER_APPROVAL_TOTAL", { query: this.searchData, status });

      this.paginationOptions = options;
      const offset  = (options.page - 1) * options.itemsPerPage;
      const sortBy  = options.sortBy.length ? (options.sortBy[0] == 'index' ? 'username' : options.sortBy[0]) : 'username';
      const sortDir = options.sortDesc.length ? (options.sortDesc[0] ? 'desc' : 'asc') : 'asc';
      this.$store.commit('CLEAR_USER_APPROVAL');
      this.$store.dispatch("LOAD_USER_APPROVAL", {
        offset: offset,
        limit: options.itemsPerPage,
        sort_by: sortBy,
        sort_dir: sortDir,
        query: this.searchData,
        status
      }).then(() => this.loadingUser = false);
    },
    doSearch() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.paginationOptions.page     = 1;
        this.paginationOptions.sortBy   = [];
        this.paginationOptions.sortDesc = [];
        this.updatePaging(this.paginationOptions)
      }, 1e3)
    },
  },
};
</script>
<style lang="css">
.custom-highlight-row{
  background-color:#f3b6b6 ;
}
</style>
